import { observer } from 'mobx-react-lite'
import GapDialog from 'reusable/gap-dialog/GapDialog'
import { DialogSize } from '@gap/shared/theme'
import { useOrgSubscriptionTierStore } from 'features/main/main-router/org-guard/main-container/org-subscription-tiers/OrgSubscriptionTierStore'
import { BillingStoreProvider } from './BillingStore'
import { PlanGrid } from './PlanGrid'

// Ensure that when we have 3 or more plans, we use the larger modal size
const dialogSizeForPlanCount = (planCount: number): DialogSize => (planCount >= 3 ? 'extra large' : 'large')

export default observer(function ChangePlanDialog() {
   const { planPicker } = useOrgSubscriptionTierStore()

   const planTabs = [
      { label: 'Individual plans', component: <PlanGrid plans={planPicker.individualPlans} />, size: dialogSizeForPlanCount(planPicker.individualPlans.length) },
      { label: 'Multi-user plans', component: <PlanGrid plans={planPicker.multiUserPlans} />, size: dialogSizeForPlanCount(planPicker.multiUserPlans.length) },
   ]

   return <BillingStoreProvider store={planPicker}>
      <GapDialog modalState={planPicker.plansDialog} title={planPicker.plansDialogTitle} size="large" tabs={planTabs} initialTabIndex={planPicker.defaultPlanTabIndex} />
   </BillingStoreProvider>
})
